import { FormTemplate } from '@employ-engage/data';
import DuplicateTemplateForm from '../duplicate-template-form/duplicate-template-form';
import Modal from '../modal/modal';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { useTranslation } from 'react-i18next';

export interface DuplicateTemplateModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  templateSelectedForDuplication?: FormTemplate;
  refetchFormTemplates: () => void;
}

export function DuplicateTemplateModal({
  open,
  setOpen,
  templateSelectedForDuplication,
  refetchFormTemplates,
}: DuplicateTemplateModalProps) {
  const { t } = useTranslation(['common']);
  return (
    <Modal open={open} setOpen={setOpen}>
      <div>
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-3xl font-bold leading-9 text-gray-900">
            {t('Duplicate Template')}
          </h1>
          {templateSelectedForDuplication ? (
            <DuplicateTemplateForm
              onClose={() => setOpen(false)}
              templateSelectedForDuplication={templateSelectedForDuplication}
              refetchFormTemplates={refetchFormTemplates}
            />
          ) : (
            <LoadingSpinner spinnerId="duplicate-template-modal-loading" />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default DuplicateTemplateModal;
